var FcLocationEnvironmentInputModule = /** @class */ (function () {
    function FcLocationEnvironmentInputModule() {
    }
    return FcLocationEnvironmentInputModule;
}());
export { FcLocationEnvironmentInputModule };
